// Central registry of every key written to browser storage.
// Before adding a new key, add it here first.

export const STORAGE_KEYS = {
  // Auth
  AUTH_TOKEN:   'customer_management_token',
  USERNAME:     'username',
  TENANT_ID:    'tenantId',
  TENANT_TOKEN: 'tenantToken',

  // UI state (localStorage — survive tab close)
  SIDEBAR_COLLAPSED: 'sidebar_collapsed',
  APP_THEME:         'app_theme',
};

// Dynamic key builders — use these instead of inline string templates
export const draftKey     = (route, id) => id ? `form_draft_${route}_${id}` : `form_draft_${route}`;
export const apiCacheKey  = (url)        => `api_cache_${url}`;
export const listStateKey = (pathname)   => `list_state_${pathname}`;
